// This file is generated by tools/generate-version.mjs. Do not edit manually.
import type { ApplicationVersion } from '@core/interfaces/application-version.interface';

export const currentApplicationVersion = {
  version: '0.0.0',
  buildId: '10167114-61903767-development-658e2d2cb45138414f01e848a082a327a3df97dc',
} satisfies ApplicationVersion;
